import { Outlet } from "react-router-dom";
import { useAuthentication } from "hooks";
import {
 BottomNavbar,
 Loader,
 OfflineDialog,
 TopNavbar,
 Snack,
 ConfirmDialog,
} from "components";

export function Layout() {
 const { loading, user } = useAuthentication();

 if (loading) {
  return <Loader loadingMessage="Loading..." />;
 }

 return (
  <>
   {user && <TopNavbar />}
   <OfflineDialog />
   <Outlet />
   <BottomNavbar />
   <Snack />
   <ConfirmDialog />
  </>
 );
}
